import { createDecorator } from './legacy-deps';
// eslint-disable-next-line no-shadow
export var IInstantiationHookPoint;
(function (IInstantiationHookPoint) {
    IInstantiationHookPoint[IInstantiationHookPoint["POST_CONSTRUCTOR"] = 0] = "POST_CONSTRUCTOR";
})(IInstantiationHookPoint || (IInstantiationHookPoint = {}));
export const IInstantiationService = createDecorator('IInstantiationService');
//# sourceMappingURL=instantiation.js.map